// export const REACT_APP_API_URL = 'https://apiiec.trudenty.com/api';
// export const REACT_APP_API_URL = 'http://localhost:8000/api';
export const REACT_APP_API_URL =
  "https://apis.trustnetwork.trudenty.net/console";
export const REACT_APP_URL = "https://consumer.trustnetwork.trudenty.net";
// export const REACT_APP_URL = "http://localhost:3000";
export const REACT_ENV: string = "staging"; // "development", "staging", "production"
export const ABSOLUTE_MS = 8 * 60 * 60 * 1000; // 8 hours
export const IDLE_MS = 15 * 60 * 1000; // 15 minutes
// export const REACT_APP_API_URL = 'https://consolestagingapi.trudenty.net/api';
